module.exports = __webpack_public_path__ + "static/media/bugFix.e451b263.svg";